import { useNavigate } from 'react-router';

import { EmptyState, Screen } from '@/components/ui';
import { texts } from '@/lib/texts';

export function NotFoundScreen() {
  const navigate = useNavigate();
  return (
    <Screen>
      <EmptyState
        title={texts.common.notFoundTitle}
        body={texts.common.notFoundBody}
        actionLabel={texts.common.toHome}
        onAction={() => void navigate('/', { replace: true })}
      />
    </Screen>
  );
}
